import React, { useEffect } from 'react'
import CustomSelect from 'components/Select'
import { useSelector } from 'react-redux'
import {
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from 'reactstrap'
import { ApplicationState } from 'store'
import { ATENDIMENTO } from 'store/modules/atendimento/types'
import { SimpleTitleCard } from 'styles/global'
import {
  BtnActionModal,
  CardRedirecionamentoKanban
} from 'views/atendimento/style'
import { FiTarget } from 'react-icons/fi'
import useRedux from 'hooks/useRedux'
import * as atendimentoActions from 'store/modules/atendimento/actions'
import { toast } from 'react-toastify'

interface ModalKanbanProps {
  isOpen: boolean
  onToggle: () => void
  index: number
}
const ModalKanban = ({ isOpen, onToggle, index }: ModalKanbanProps) => {
  const { atendimentosAbertos } = useSelector<ApplicationState, ATENDIMENTO>(
    (state) => state.atendimento
  )

  const { dispatch } = useRedux()

  const nomeCliente = atendimentosAbertos[index].tabContato.nome

  function onChange(value: string, field: string) {
    let register
    if (field === 'pipelineId') {
      register = {
        ...atendimentosAbertos[index].tabContato.modalKanban.register,
        pipelineEtapaId: '',
        [field]: value
      }
    } else {
      register = {
        ...atendimentosAbertos[index].tabContato.modalKanban.register,
        [field]: value
      }
    }
    dispatch(
      atendimentoActions.setModalKanbanField(register, 'register', index)
    )
  }

  function adicionarClienteKanban() {
    if (
      !atendimentosAbertos[index].tabContato.modalKanban.register.pipelineId
    ) {
      return toast.warn('Selecione o pipeline')
    }
    if (
      !atendimentosAbertos[index].tabContato.modalKanban.register
        .pipelineEtapaId
    ) {
      return toast.warn('Selecione a etapa')
    }
    dispatch(atendimentoActions.adicionarClienteKanbanSaga(index))
  }

  useEffect(() => {
    if (isOpen) {
      dispatch(atendimentoActions.getPipelinesSaga(index))
    }
  }, [dispatch, index, isOpen])

  useEffect(() => {
    if (
      isOpen &&
      atendimentosAbertos[index].tabContato.modalKanban.register.pipelineId
    ) {
      dispatch(atendimentoActions.getEtapasSaga(index))
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [
    atendimentosAbertos[index].tabContato.modalKanban.register.pipelineId,
    isOpen,
    dispatch,
    index
  ])
  //* eslint-enable react-hooks/exhaustive-deps */

  return (
    <Modal size="md" isOpen={isOpen} toggle={() => onToggle()}>
      <ModalHeader
        toggle={() => {
          onToggle()
        }}
      >
        <SimpleTitleCard>
          <FiTarget className="icon" />
          Direcionar {nomeCliente} para Kanban
        </SimpleTitleCard>
      </ModalHeader>
      <ModalBody>
        <div className="d-flex flex-column gap-2">
          <Row>
            <Col>
              <Label>Selecione o pipeline</Label>
              <CustomSelect
                placeholder="Selecione"
                options={
                  atendimentosAbertos[index].tabContato.optionsSelect.pipelines
                }
                accessorLabel="descricao"
                accessorValue="id"
                onChange={(e) => {
                  onChange(e, 'pipelineId')
                }}
                value={
                  atendimentosAbertos[index].tabContato.modalKanban.register
                    .pipelineId
                }
              />
            </Col>
          </Row>
          <Row className="d-flex row-gap-15">
            <Col>
              <Label>Selecione a etapa</Label>
              <CustomSelect
                placeholder="Selecione"
                options={
                  atendimentosAbertos[index].tabContato.optionsSelect.etapas
                }
                accessorLabel="descricao"
                accessorValue="id"
                onChange={(e) => {
                  onChange(e, 'pipelineEtapaId')
                }}
                value={
                  atendimentosAbertos[index].tabContato.modalKanban.register
                    .pipelineEtapaId
                }
              />
            </Col>
          </Row>
          {atendimentosAbertos[index].tabContato.modalKanban.register
            .pipelineId &&
            atendimentosAbertos[index].tabContato.modalKanban.register
              .pipelineEtapaId && (
              <Row>
                <Col>
                  <CardRedirecionamentoKanban>
                    <div className="d-flex flex-column">
                      <Label className="titulo">
                        {nomeCliente} será redirecionado para:
                      </Label>
                      <span className="subtitulo">
                        <strong>
                          {
                            atendimentosAbertos[
                              index
                            ].tabContato.optionsSelect.etapas.find(
                              (etapa) =>
                                etapa.id ===
                                atendimentosAbertos[index].tabContato
                                  .modalKanban.register.pipelineEtapaId
                            )?.descricao
                          }
                        </strong>
                        &nbsp;no pipeline&nbsp;
                        <strong>
                          {
                            atendimentosAbertos[
                              index
                            ].tabContato.optionsSelect.pipelines.find(
                              (pipeline) =>
                                pipeline.id ===
                                atendimentosAbertos[index].tabContato
                                  .modalKanban.register.pipelineId
                            )?.descricao
                          }
                        </strong>
                      </span>
                    </div>
                  </CardRedirecionamentoKanban>
                </Col>
              </Row>
            )}
        </div>
      </ModalBody>
      <ModalFooter>
        <BtnActionModal onClick={onToggle} className="btn-cancel">
          <span>Cancelar</span>
        </BtnActionModal>
        <BtnActionModal
          onClick={adicionarClienteKanban}
          className="btn-confirm"
        >
          <FiTarget className="icon" />
          <span>Direcionar Cliente</span>
        </BtnActionModal>
      </ModalFooter>
    </Modal>
  )
}

export default ModalKanban
